import digital1 from '../Assets/img-min/portfolio/Elecsbe_1.webp';
import digital2 from '../Assets/img-min/portfolio/Elecsbe_2.webp';
import digital3 from '../Assets/img-min/portfolio/Telecoise_1.webp';
import digital4 from '../Assets/img-min/portfolio/Alliance_1.jpg';
import digital5 from '../Assets/img-min/portfolio/Alliance_2.jpg';
import digital6 from '../Assets/img-min/portfolio/BarsiSmagam_1.webp';
import digital7 from '../Assets/img-min/portfolio/BarsiSmagam_2.webp';
import digital8 from '../Assets/img-min/portfolio/DomeHelp_1.webp';
import digital9 from '../Assets/img-min/portfolio/DomeHelp_2.webp';
import digital10 from '../Assets/img-min/portfolio/Coinbranch_1.webp';
import digital11 from '../Assets/img-min/portfolio/coinbranch_2.webp';
import digital12 from '../Assets/img-min/portfolio/Mannelec.webp';
import digital13 from '../Assets/img-min/portfolio/Mannelec_1.webp';
import digital14 from '../Assets/img-min/portfolio/SunTrackEnergy_1.webp';
import digital15 from '../Assets/img-min/portfolio/SunTrackEnergy_2.webp';
import digital16 from '../Assets/img-min/portfolio/Gasomatic_1.webp';
import digital17 from '../Assets/img-min/portfolio/Gasomatic_2.webp';
import digital18 from '../Assets/img-min/portfolio/HSRImmigration_1.webp';
import digital19 from '../Assets/img-min/portfolio/HSRImmigration_2.webp';
import digital20 from '../Assets/img-min/portfolio/EMO_1.webp';
import digital21 from '../Assets/img-min/portfolio/Eclumes_1.png';
import digital22 from '../Assets/img-min/portfolio/Eclumes_2.png';
import digital23 from '../Assets/img-min/portfolio/Dameinkrisl_1.webp';
import digital24 from '../Assets/img-min/portfolio/Dameinkrisl_2.webp';
import digital25 from '../Assets/img-min/portfolio/ApDiamondFull_1.webp';
import digital26 from '../Assets/img-min/portfolio/100Blackman_1.webp';
import digital27 from '../Assets/img-min/portfolio/AllAmerican_1.webp';
import digital28 from '../Assets/img-min/portfolio/MCSD_1.webp';
import digital29 from '../Assets/img-min/portfolio/MDES_1.webp';
import digital30 from '../Assets/img-min/portfolio/MagicHand_1.webp';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';

function PortfolioContent() {
  const [visible, setVisible] = useState(false);
  const [PopupImage, setPopupImage] = useState('');
  const [Title, SetTitle] = useState('');
  const [Url, SetUrl] = useState('')
  function InsertImage(digitalImage, ImageTitle, url) {
    setPopupImage(digitalImage);
    setVisible(true);
    SetTitle(ImageTitle)
    SetUrl(url);
  }
  return (
    <>
      <div id="portfolio" className="section py-6 bg-white-black bg-body">
        <div className="container">
          <header className="text-center mx-auto mb-5">
            <h2 className="h3 fw-bold"><span className="fw-light">Our</span> Portfolio</h2>
            <hr className="divider my-4 bg-warning border-warning" />
          </header>
          <div className="grid portfolio row g-0 lightgallery-thumbnail">

            <figure className="col-sm-6 col-lg-4 portfolio-item branding p-3 " data-src="src/img-min/portfolio/digital1.jpg" data-sub-html="Logo Design" data-aos="fade-up" data-aos-delay="100">
              <img className="portfolio-image-3 border" src={digital1} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital2, 'ELEC SBE', 'https://www.elecsbe.com/FR/index.html')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">ELEC SBE</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item web p-3 " data-src="src/img-min/portfolio/digital6.jpg" data-sub-html="Apps Development" data-aos="fade-up" data-aos-delay="300">
              <img className="portfolio-image-3 border" src={digital3} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital3, 'Telecoise', 'https://www.telecoise.com/FrontServer/EHome.aspx')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">Telecoise</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item branding p-3 " data-src="../Assets/img-min/portfolio/Alliance_1.webp" data-sub-html="Logo Design" data-aos="fade-up" data-aos-delay="500">
              <img className="portfolio-image-3 border" src={digital4} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital5, 'Alliance', 'https://design.alliancefr.fr/')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">Alliance</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item branding p-3 " data-src="src/img-min/portfolio/digital26.jpg" data-sub-html="Logo Design" data-aos="fade-up" data-aos-delay="100">
              <img className="portfolio-image-3 border" src={digital6} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital7, 'BARSI SMAGAM FRANCE', 'https://barsismagamfrance.fr/')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">BARSI SMAGAM FRANCE</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item web p-3 " data-src="src/img-min/portfolio/digital6.jpg" data-sub-html="Apps Development" data-aos="fade-up" data-aos-delay="300">
              <img className="portfolio-image-3 border" src={digital8} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital9, 'DomeHelp', 'https://www.domehelp.com/')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">DomeHelp</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item web p-3 " data-src="src/img-min/portfolio/digital6.jpg" data-sub-html="Apps Development" data-aos="fade-up" data-aos-delay="500">
              <img className="portfolio-image-3 border" src={digital10} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital11, 'CoinBrach', 'https://coinbranch.org/')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">CoinBrach</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item branding p-3 " data-src="src/img-min/portfolio/digital15.jpg" data-sub-html="Logo Design" data-aos="fade-up" data-aos-delay="100">
              <img className="portfolio-image-3 border" src={digital12} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital13, 'Mann ElectroTechnical Ltd', 'https://www.mannelec.uk/')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">Mann ElectroTechnical Ltd</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item branding p-3 " data-src="src/img-min/portfolio/digital19.jpg" data-sub-html="Logo Design" data-aos="fade-up" data-aos-delay="300">
              <img className="portfolio-image-3 border" src={digital14} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital15, 'Sun Track Energy Solution Ltd', 'https://suntrackenergy.co.uk/')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">Sun Track Energy Solution Ltd</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item branding p-3 " data-src="src/img-min/portfolio/digital21.jpg" data-sub-html="Logo Design" data-aos="fade-up" data-aos-delay="500">
              <img className="portfolio-image-3 border" src={digital16} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital17, 'Gasomatics Ltd', 'https://www.gasomaticltd.co.uk/')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">Gasomatics Ltd</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item branding p-3 " data-src="src/img-min/portfolio/digital17.jpg" data-sub-html="Logo Design" data-aos="fade-up" data-aos-delay="100">
              <img className="portfolio-image-3 border" src={digital18} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital19, 'HSR Immigration', 'https://hsrimmigration.com/')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">HSR Immigration</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

             <figure className="col-sm-6 col-lg-4 portfolio-item photovid p-3 " data-src="src/img-min/portfolio/digital5.jpg" data-sub-html="Photography" data-aos="fade-up" data-aos-delay="300">
              <img className="portfolio-image-3 border" src={digital20} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital20, 'Mobile Office')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">Mobile Office</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item branding p-3 " data-src="src/img-min/portfolio/digital25.jpg" data-sub-html="Logo Design" data-aos="fade-up" data-aos-delay="500">
              <img className="portfolio-image-3 border" src={digital21} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital22, 'Eclumes', 'https://eclumes.com/')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">Eclumes</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item branding p-3 " data-src="src/img-min/portfolio/digital23.jpg" data-sub-html="Logo Design" data-aos="fade-up" data-aos-delay="100">
              <img className="portfolio-image-3 border" src={digital23} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital24, 'Damien Krisl', 'https://damienkrisl.com/')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">Damien Krisl</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item branding graphic p-3 " data-src="src/img-min/portfolio/digital4.jpg" data-sub-html="Video" data-aos="fade-up" data-aos-delay="300">
              <img className="portfolio-image-3 border" src={digital25} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital25, 'AP Daimond')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">AP Daimond</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item photovid branding web p-3 " data-src="src/img-min/portfolio/digital2.jpg" data-sub-html="Web Development" data-aos="fade-up" data-aos-delay="500">
              <img className="portfolio-image-3 border" src={digital26} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital26, '100 Blackman')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">100 Blackman</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item graphic p-3 " data-src="src/img-min/portfolio/digital3.jpg" data-sub-html="Graphic Design" data-aos="fade-up" data-aos-delay="100">
              <img className="portfolio-image-3 border" src={digital27} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital27, 'All American')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">All American</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item web p-3 " data-src="src/img-min/portfolio/digital6.jpg" data-sub-html="Apps Development" data-aos="fade-up" data-aos-delay="300">
              <img className="portfolio-image-3 border" src={digital28} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital28, 'MCSD')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">MCSD</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item web p-3 " data-src="src/img-min/portfolio/digital6.jpg" data-sub-html="Apps Development" data-aos="fade-up" data-aos-delay="500">
              <img className="portfolio-image-3 border" src={digital29} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital29, 'MDES')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">MDES</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>

            <figure className="col-sm-6 col-lg-4 portfolio-item web p-3 " data-src="src/img-min/portfolio/digital6.jpg" data-sub-html="Apps Development" data-aos="fade-up" data-aos-delay="100">
              <img className="portfolio-image-3 border" src={digital30} alt="Image Description" style={{ width: '100%', height: '100%' }} />
              <figcaption className="portfolio-info-3" onClick={() => InsertImage(digital30, 'Magic Hand')}>
                <div className="portfolio-info-content-3">
                  <h3 className="h5 mb-3 text-white">Magic Hand</h3>
                  <svg className="bi bi-plus text-white" width="2.5rem" height="2.5rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0 01.5-.5z" clipRule="evenodd"></path>
                    <path fillRule="evenodd" d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z" clipRule="evenodd"></path>
                  </svg>
                </div>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
      <div className="container">
        <div className='row'>
          <Modal show={visible} onHide={() => setVisible(false)}  >
            <Modal.Header closeButton >
              <Modal.Title>
                {Url === '' ? (
                  Title
                ) : (
                  <a href={Url} target="_blank" rel="noopener noreferrer">
                    {Title}
                  </a>
                )}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <img className="portfolio-image-3 " src={PopupImage} alt='Popup Image' width={600} height={600} />
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
}
export default PortfolioContent;